// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-area-multi';

export const Component = () => (
  <path d='M0 0h1v21h21v1H0V0Zm3 8 3.188 4 4.25-3L20 17v2H3V8Zm17-4.546v11.322L12 8l3.31-1.033L17 8l3-4.546Z' />
);

export const viewBox = '0 0 22 22';
